<template>
  <!-- If you don't see scrollbar showing up, please open dev-tool to checkout whether your child's size is
  greater than parent's. The condition for the scrollbar to appear is the same as the native scrollbar, that is,
  the size of the child element exceeds the parent element -->
  <div>
    <div :style="height ? 'height:' + height : ''">
      <vuescroll :ops="ops">
        <slot name="scrollableContent"></slot>
      </vuescroll>
    </div>
    <slot name="nonScrollableFooter"></slot>
  </div>

</template>

<script>
import vuescroll from 'vuescroll'

export default {
  name: 'fin-vue-scroll',
  components: {
    vuescroll
  },
  data() {
    return {
      // see possible configurations: https://vuescrolljs.yvescoding.org/guide/configuration.html#vuescroll
      ops: {
        vuescroll: {
          mode: 'native',
          sizeStrategy: 'percent',
          detectResize: true,
          /** Enable locking to the main axis if user moves only slightly on one of them at start */
          locking: true,
        },
        scrollPanel: {
          initialScrollY: false,
          initialScrollX: false,
          scrollingX: true,
          scrollingY: true,
          speed: 300,
          easing: undefined,
          verticalNativeBarPos: 'right'
        },
        rail: {
          background: '#f5f8f9',
          opacity: 0,
          size: '6px',
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: '2px',
          keepShow: true
        },
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: true,
          keepShow: true,
          background: '#cfd1d3',
          opacity: 0.75,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: 0.1,
          size: '4px',
          disable: false
        }
      }
    }
  },
  props: {
    height: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>

// to avoid horizontal native scrollbars to be displayed
::v-deep .__view {
  max-width: 100%;
}

</style>
